/**
 * 移动端智能商品规格校验与加入购物车控制器
 * 无动画无通知，只关闭弹窗
 */
class MobileSmartAddToCart {
    constructor() {
        // 仅移动端运行
        if (window.innerWidth >= 768) return;

        this.stickyAddToCartButton = document.getElementById('show-sticky-product');
        this.init();
    }

    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
        } else {
            this.setupEventListeners();
        }
    }

    setupEventListeners() {
        const btn = this.stickyAddToCartButton || document.getElementById('show-sticky-product');
        if (btn) {
            btn.addEventListener('click', (e) => this.handleStickyAddToCartClick(e));
        }
    }

    handleStickyAddToCartClick(e) {
        e.preventDefault();
        e.stopPropagation();

        const mainProductForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
                                document.querySelector('.productView-form form') ||
                                document.querySelector('form[action="/cart/add"]');

        if (!mainProductForm) {
            this.openMobileOptionsDrawer();
            return;
        }

        const colorRadios = mainProductForm.querySelectorAll('input[type="radio"][name="Color"]');
        const sizeRadios = mainProductForm.querySelectorAll('input[type="radio"][name="Size"]');

        const hasColor = colorRadios.length > 0;
        const hasSize = sizeRadios.length > 0;

        let requiredSelectionsCount = 0;
        if (hasColor) requiredSelectionsCount++;
        if (hasSize) requiredSelectionsCount++;

        if (requiredSelectionsCount === 0 && mainProductForm.querySelectorAll('fieldset').length > 0) {
            requiredSelectionsCount = mainProductForm.querySelectorAll('fieldset').length;
        }

        let currentSelectedCount = 0;
        if (hasColor && mainProductForm.querySelector('input[type="radio"][name="Color"]:checked')) currentSelectedCount++;
        if (hasSize && mainProductForm.querySelector('input[type="radio"][name="Size"]:checked')) currentSelectedCount++;

        if (currentSelectedCount === 0 && requiredSelectionsCount > 0) {
            currentSelectedCount = mainProductForm.querySelectorAll('fieldset input[type="radio"]:checked').length;
        }

        if (requiredSelectionsCount === 0 || currentSelectedCount >= requiredSelectionsCount) {
            this.executeAjaxAddToCart(mainProductForm, document.getElementById('show-sticky-product'));
        } else {
            this.openMobileOptionsDrawer();
        }
    }

    openMobileOptionsDrawer() {
        document.body.classList.add('show-mobile-options', 'cart-popup-open');
        let overlay = document.querySelector('.dynamic-drawer-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'dynamic-drawer-overlay';
            overlay.addEventListener('click', () => this.closeMobileOptionsDrawer());
            document.body.appendChild(overlay);
        }
        setTimeout(() => { overlay.classList.add('is-active'); }, 10);
    }

    closeMobileOptionsDrawer() {
        document.body.classList.remove('show-mobile-options', 'cart-popup-open');
        const overlay = document.querySelector('.dynamic-drawer-overlay');
        if (overlay) {
            overlay.classList.remove('is-active');
            setTimeout(() => { if (!overlay.classList.contains('is-active') && overlay.parentNode) overlay.remove(); }, 300);
        }
    }

    executeAjaxAddToCart(activeForm, clickedButton) {
        const variantIdInput = activeForm.querySelector('input[name="id"]');
        if (!variantIdInput || !variantIdInput.value) return;

        if (clickedButton) {
            clickedButton.setAttribute('disabled', true);
            clickedButton.style.opacity = '0.6';
        }

        const payload = { id: parseInt(variantIdInput.value), quantity: 1 };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(() => {
            // 只关闭弹窗，无动画无通知
            this.closeMobileOptionsDrawer();

            // 触发飞入购物车动画
            const pdpModal = document.querySelector('.custom-qshop-modal.m-pdp-sync');
            if (pdpModal && typeof pdpModal.runFlyToCartAnimation === 'function') {
                pdpModal.runFlyToCartAnimation(clickedButton, () => {
                    pdpModal.updateCartCount();
                });
            }
        })
        .catch(err => console.error('Ajax Add Error:', err))
        .finally(() => {
            if (clickedButton) {
                clickedButton.removeAttribute('disabled');
                clickedButton.style.opacity = '1';
            }
        });
    }
}

if (typeof window !== 'undefined') {
    window.mobileSmartAddToCartInstance = new MobileSmartAddToCart();
}
